export default __webpack_public_path__ + "static/media/reset.16b7f2a7.svg";